// components/UnderConstruction.tsx
import { motion } from 'framer-motion';

export default function UnderConstruction({ icon, title, description }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, ease: 'easeOut' }}
      className="min-h-[70vh] flex flex-col items-center justify-center px-6 text-center"
    >
      <div className="text-purple-600 mb-4">{icon}</div>
      <h1 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-2">
        {title}
      </h1>
      {description && <p className="text-gray-600 max-w-md">{description}</p>}
    </motion.div>
  );
}
